import React from 'react';
import classnames from 'classnames';
import CloseIcon from '@material-ui/icons/Clear';
import toBe from 'prop-types';
import classes from './notification.scss';
const Notification = ({
  text,
  isShown,
  onClose,
  dataAttr
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.container, {
    [classes.isShown]: isShown
  }),
  "data-notification": dataAttr
}, text, /*#__PURE__*/React.createElement(CloseIcon, {
  className: classes.closeIcon,
  onClick: onClose
}));
export default Notification;
Notification.propTypes = {
  text: toBe.string,
  dataAttr: toBe.string,
  isShown: toBe.bool,
  onClose: toBe.func
};